import AuthService from './authService';

export default class PlanningExportService {
  static async Export(level, granularity, selectedIds) {
    const body = { Level: level, Granularity: granularity, SelectedIds: selectedIds };
    const url = '/api/PlanningExport/Export';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(body));
  }
}
